import routes from './account.routes'

export const accountModule = {
  routes
}
